module.exports = __webpack_public_path__ + "img/JOC_2935.59a4276c.jpg";